module.exports = __webpack_public_path__ + "static/media/Background_8.ac4af9f6.svg";